import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-blue",
  "use": "arrow-down-blue-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down-blue\"><path d=\"M4.78 4.024l1.92-2.4A1 1 0 0 0 5.92 0H2.08a1 1 0 0 0-.78 1.625l1.92 2.399a1 1 0 0 0 1.56 0z\" fill=\"#2E5DD2\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol